export default __webpack_public_path__ + "static/media/mc_eject_rotor.24031a1e.svg";